module.exports = "/_next/static/images/chicago-fast-channel-description-image-black-letters-8c59e059fc6001d5a91d29211bcf1b8c.svg";